/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConnectorDto
 */
export interface ConnectorDto {
    /**
     * Unique label combines device id and connector index/label
     * @type {string}
     * @memberof ConnectorDto
     */
    connectorUniqueLabel?: string;
    /**
     *
     * @type {Date}
     * @memberof ConnectorDto
     */
    createdAt?: Date;
    /**
     *
     * @type {string}
     * @memberof ConnectorDto
     */
    connectorType?: ConnectorDtoConnectorTypeEnum;
    /**
     * 1-based connector index
     * @type {number}
     * @memberof ConnectorDto
     */
    connectorIndex?: number;
    /**
     * Customer-facing label, eg 'Port A'
     * @type {string}
     * @memberof ConnectorDto
     */
    connectorLabel?: string;
    /**
     * Connector status mapped to an enum
     * @type {string}
     * @memberof ConnectorDto
     */
    connectorState?: ConnectorDtoConnectorStateEnum;
    /**
     * Raw connector status as reported from the device. Eg Available,SuspendedEV,Unknown
     * @type {string}
     * @memberof ConnectorDto
     */
    connectorStatus?: string;
}

/**
 * @export
 */
export const ConnectorDtoConnectorTypeEnum = {
    Unknown: "Unknown",
    ChAdeMo: "CHAdeMO",
    Ccs: "CCS",
    Ccs2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    Mcs: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;
export type ConnectorDtoConnectorTypeEnum =
    (typeof ConnectorDtoConnectorTypeEnum)[keyof typeof ConnectorDtoConnectorTypeEnum];

/**
 * @export
 */
export const ConnectorDtoConnectorStateEnum = {
    Unknown: "Unknown",
    Available: "Available",
    Preparing: "Preparing",
    Charging: "Charging",
    Discharging: "Discharging",
    Suspended: "Suspended",
    Finishing: "Finishing",
    FullyCharged: "FullyCharged",
    Reserved: "Reserved",
    Unavailable: "Unavailable",
    Faulted: "Faulted",
} as const;
export type ConnectorDtoConnectorStateEnum =
    (typeof ConnectorDtoConnectorStateEnum)[keyof typeof ConnectorDtoConnectorStateEnum];

/**
 * Check if a given object implements the ConnectorDto interface.
 */
export function instanceOfConnectorDto(value: object): value is ConnectorDto {
    return true;
}

export function ConnectorDtoFromJSON(json: any): ConnectorDto {
    return ConnectorDtoFromJSONTyped(json, false);
}

export function ConnectorDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorDto {
    if (json == null) {
        return json;
    }
    return {
        connectorUniqueLabel:
            json["connectorUniqueLabel"] == null
                ? undefined
                : json["connectorUniqueLabel"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        connectorType:
            json["connectorType"] == null ? undefined : json["connectorType"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        connectorLabel:
            json["connectorLabel"] == null ? undefined : json["connectorLabel"],
        connectorState:
            json["connectorState"] == null ? undefined : json["connectorState"],
        connectorStatus:
            json["connectorStatus"] == null
                ? undefined
                : json["connectorStatus"],
    };
}

export function ConnectorDtoToJSON(value?: ConnectorDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        connectorUniqueLabel: value["connectorUniqueLabel"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        connectorType: value["connectorType"],
        connectorIndex: value["connectorIndex"],
        connectorLabel: value["connectorLabel"],
        connectorState: value["connectorState"],
        connectorStatus: value["connectorStatus"],
    };
}
